import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=4cb16ca4&"
import script from "./Installation.vue?vue&type=script&lang=ts&"
export * from "./Installation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports